import { render } from "./InvoiceDetailTab.vue?vue&type=template&id=618f9724&scoped=true"
import script from "./InvoiceDetailTab.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTab.vue?vue&type=script&lang=js"

import "./InvoiceDetailTab.vue?vue&type=style&index=0&id=618f9724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618f9724"]])

export default __exports__